export default "__VITE_ASSET__47036e59__"